import { ItemType } from 'antd/lib/menu/hooks/useItems';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import {
  Sidebar,
  PageWrapper,
  Title,
  PageContent,
  MainContent,
  SidebarMenu,
} from 'components/organisms/pages/shared/styles';

const CenteredContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const StyledSidebar = styled(Sidebar)`
  .ant-layout-sider-children .ant-menu .ant-menu-item {
    height: 32px;
    margin-bottom: 0;
  }

  .ant-menu-item-selected {
    background-color: var(--blue-20) !important;
  }
`;

export type SignalsV2ViewType = 'summary' | 'reasons' | 'timeline';

interface SignalsV2LayoutProps {
  selectedView: SignalsV2ViewType;
  onViewChange: (view: SignalsV2ViewType) => void;
  children: React.ReactNode;
}

export const SignalsV2Layout: React.FC<SignalsV2LayoutProps> = ({
  selectedView,
  onViewChange,
  children,
}) => {
  const sidebarItems = useMemo((): ItemType[] => {
    return [
      {
        key: 'summary',
        label: <Title>Summary</Title>,
      },
      {
        key: 'reasons',
        label: <Title>Reasons</Title>,
      },
      {
        key: 'timeline',
        label: <Title>Timeline</Title>,
      },
    ];
  }, []);

  const SideBar = useMemo(() => {
    return (
      <div className="flex flex-col">
        <SidebarMenu
          items={sidebarItems}
          onSelect={({ key }) => {
            onViewChange(key as SignalsV2ViewType);
          }}
          selectedKeys={[selectedView]}
          mode="inline"
        />
      </div>
    );
  }, [sidebarItems, selectedView, onViewChange]);

  return (
    <PageWrapper>
      <StyledSidebar>{SideBar}</StyledSidebar>
      <PageContent>
        <MainContent>
          <CenteredContent>{children}</CenteredContent>
        </MainContent>
      </PageContent>
    </PageWrapper>
  );
};
